hrd.config.PresentationStorage = hrd.Class.extend({
	init: function(options){
		var defaults = {
			impl: 'hrd.config.PresentationStorage',
		};
		this._super($.extend({}, defaults, options));
		this.tb = new hrd.Toolbox();
	},
	getSessionKey: function(){
		var	tenant = this.tb.get('globals.prefs.tenant.systenant', hrd, '-20');
		return 'PRESENTATION_CONFIG_FOR_' + tenant;
	},
	read: function(){
		var data = Storages.localStorage.get(this.getSessionKey());
		return data;
	},
	write: function(data){
		Storages.localStorage.set(this.getSessionKey(), data);
	}
});